export const pluralize = (count: number, singular: string, plural: string = singular): string => {
  if (count === -1 || count === 1) {
    return singular;
  }

  return plural;
};

export const pluralizeWithCount = (count: number, singular: string, plural: string = singular): string => {
  return `${count} ${pluralize(count, singular, plural)}`;
};



// WEBPACK FOOTER //
// ./src/utils/stringUtils.tsx